import { gql } from "apollo-angular";

export const GET_CATALOG_BRANDS = gql`
    query GetCatalogBrands($take: Int, $skip: Int, $filterTerm: String) {
        catalogBrands(take: $take, skip: $skip, filterTerm: $filterTerm) {
            items {
                id
                name
                code
            }
            totalItems
        }
    }
`;
